<template>
    <div class="py-2">
        <DateBadge
            v-for="(dateObj, index) in value"
            :date="dateObj.date"
            :has-series="dateObj.hasSeries"
            :index="index"
            :key="`db-k-${index}`"
            @badge-remove="$emit('badge-list-remove', index)"
        ></DateBadge>
    </div>
</template>

<script>
    import DateBadge from "./DateBadge";

    /**
     * Used to show picked separate dates for
     * inclinometer charts. This is the whole list.
     */

    export default {
        name: "DateBadgesList",
        components: {
            DateBadge
        },
        props: {
            value: {
                type: Array,
                required: true
            }
        }
    }
</script>
